module.exports = __webpack_public_path__ + "static/demo1-ru-51602180b4d9a3d52eab409f961fe24f.mp4";